import { Button, Dialog, Message, Table } from '@alifd/next';
import { Box } from '@mui/material';
import { Form, Input, Select, Typography } from 'antd';
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import ReactDragListView from 'react-drag-listview'; // 拖曳功能
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';

import EditCategory from '@/components/UI/EditCategory';
import EditService from '@/components/UI/EditService';
import client from '@/lib/feathers';

import { getFilteredFileData, keywordSearch } from './helpers';
import styles from './index.module.scss';

const { Item } = Form;
const { Option } = Select;

const CommunityFilesList = () => {
  const [form] = Form.useForm();
  const uploadRef = useRef(null);
  const categoryMenu = client.service('categoryMenu');
  const uploads = client.service('uploads');
  const [categoryArr, setCategoryArr] = useState([]);
  const [addCategory, setAddCategory] = useState('');
  const [categoryDataArr, setCategoryDataArr] = useState([]);
  const [categoryName, setCategoryName] = useState('');
  const [editCategoryIndex, setEditCategoryIndex] = useState('');
  const [editCategoryDialog, setEditCategoryDialog] = useState(false);
  const [categoryDialog, setCategoryDialog] = useState(false);
  const [fileDialog, setFileDialog] = useState(false);
  const [fileStatus, setFileStatus] = useState('insert');
  const [uploadData, setUploadData] = useState(null);
  const [attachment, setAttachment] = useState(null);
  const [editFileList, setEditFileList] = useState(null);
  const [fileData, setFileData] = useState([]);
  const [serviceCategories, setServiceCategories] = useState([]);
  const [trigger, setTrigger] = useState({});
  const [displayTableData, setDisplayTableData] = useState([]);

  const serviceData = useSelector((state) => state.service.serviceData);

  const findCategory = async () => {
    const result = await categoryMenu.find({
      query: { service: 'communityFiles' },
    });
    return result && result.data ? result.data : [];
  };
  const findFile = async () => {
    const result = await uploads.find({
      query: { type: 'communityFiles' },
    });
    return result && result.data ? result.data : [];
  };

  const serverUpdate = () => {
    findCategory()
      .then((res) => {
        setCategoryArr(res);
        setCategoryDataArr(res[0].data);
      })
      .catch((error) => {
        console.log('==categoryMenu find fail:', error);
      });
    findFile().then((res) => {
      console.log(res);
      setFileData(res);
      setDisplayTableData(res);
    });
  };
  useEffect(() => {
    serverUpdate();
  }, []);

  useEffect(() => {
    setServiceCategories(serviceData.data);
  }, [serviceData]);

  async function updateCategory(id, obj) {
    return await categoryMenu.patch(id, obj);
  }
  // 類別拖曳Function
  const onDragCategoryEnd = (fromIndex, toIndex) => {
    if (toIndex < 0) return; // Ignores if outside designated area

    const items = categoryArr[0]; // 所有類別資料
    const item = items.data.splice(fromIndex, 1)[0];
    items.data.splice(toIndex, 0, item); // 把刪除的新增到移動的位置

    updateCategory(items._id, items)
      .then((res) => {
        console.log('==categoryMenu drag categoryName success:', res);
        serverUpdate();
        Message.success('拖曳成功');
      })
      .catch((error) => {
        console.log('==categoryMenu drag categoryName fail:', error);
        Message.error(`${error}`);
      });
  };
  const onFinish = async (value) => {
    if (fileStatus === 'insert') {
      if (uploadData) {
        const body = new FormData();
        body.append('files', uploadData);
        if (uploadData.size / 1024 / 1024 > 20) {
          return Message.error('上傳檔案不能超過20MB');
        }
        const res = await axios(
          `/newUploads?type=communityFiles&category=${value.category}&database=${value.database}`,
          {
            method: 'POST',
            headers: {
              authorization: window.localStorage['feathers-jwt'],
            },
            data: body,
          }
        );
        if (res) {
          Message.success('新增成功');
          serverUpdate();
          setEditFileList(null);
          setUploadData(null);
          setAttachment(null);
          setFileDialog(false);
        }
      }
    } else if (fileStatus === 'update') {
      if (uploadData) {
        const body = new FormData();
        body.append('files', uploadData);
        if (uploadData.size / 1024 / 1024 > 20) {
          return Message.error('上傳檔案不能超過20MB');
        }
        await uploads.remove(editFileList._id);

        const res = await axios(
          `/newUploads?type=communityFiles&category=${value.category}&database=${value.database}`,
          {
            method: 'POST',
            headers: {
              authorization: window.localStorage['feathers-jwt'],
            },
            data: body,
          }
        );
        if (res) {
          Message.success('修改成功');
          serverUpdate();
          setEditFileList(null);
          setUploadData(null);
          setAttachment(null);
          setFileDialog(false);
        }
      } else {
        const res = await uploads.patch(editFileList._id, {
          database: value.database,
          category: value.category,
        });
        if (res) {
          Message.success('修改成功');
          serverUpdate();
          setEditFileList(null);
          setUploadData(null);
          setAttachment(null);
          setFileDialog(false);
        }
      }
    }
  };

  const handleSearchInputChange = (event) => {
    setTimeout(() => {
      const resultOfArray = keywordSearch({
        keyword: event.target.value,
        categoryDataArr,
        serviceCategories,
        fileData,
      });
      const filteredData = getFilteredFileData(resultOfArray, fileData);
      setDisplayTableData(filteredData);
    }, 500);
  };

  return (
    <div className={styles.container}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '10px',
          mb: '10px',
        }}
      >
        <Button
          // className={styles.btnItem1}
          onClick={() => {
            setFileDialog(true);
            setFileStatus('insert');
            setEditFileList(null);
            setUploadData(null);
            setAttachment(null);
            form.resetFields();
          }}
        >
          新增檔案
        </Button>

        <EditCategory
          buttonProps={{
            type: 'secondary',
          }}
        />
        <EditService
          buttonProps={{
            type: 'secondary',
          }}
          setIsUpdate={() => setTrigger({})}
        />
        <Input
          placeholder="請輸入關鍵字"
          onChange={handleSearchInputChange}
          allowClear
          className={styles.searchInput}
        />
      </Box>
      <Table dataSource={displayTableData}>
        <Table.Column
          title="檔案類型"
          dataIndex="category"
          cell={(val) => {
            const category = categoryDataArr.find((item) => item.id === val);
            return category ? category.name : '';
          }}
        />
        <Table.Column
          title="服務類型"
          dataIndex="database"
          cell={(val) => {
            const service = serviceCategories.find((item) => item.id === val);
            return service ? service.name : '';
          }}
        />
        <Table.Column
          title="檔案"
          dataIndex="showPath"
          cell={(value, index, record) => (
            <a target="_blank" rel="noreferrer" key={index} href={value}>
              <span role="img" aria-label="spin" aria-labelledby="">
                📎
              </span>
              {record.oldName}
            </a>
          )}
        />
        <Table.Column
          width={200}
          title="操作"
          dataIndex="_id"
          cell={(value, _index, record) => (
            <div className={styles.btn}>
              <Button
                type="normal"
                onClick={() => {
                  setFileStatus('update');
                  setEditFileList(record);
                  setFileDialog(true);
                  setAttachment(true);
                  form.setFieldsValue({
                    ...record,
                    files: [record.files],
                  });
                }}
              >
                編輯
              </Button>

              <Button
                type="primary"
                warning
                onClick={() => {
                  Swal.fire({
                    title: '確定刪除此檔案?',
                    text: '刪除後將無法復原!!',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#BEBEBE',
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                  }).then((result) => {
                    if (result.isConfirmed) {
                      Swal.fire('刪除!', '此檔案已刪除', 'success');
                      uploads.remove(value).then(() => {
                        serverUpdate();
                      });
                    }
                  });
                }}
              >
                刪除
              </Button>
            </div>
          )}
        />
      </Table>

      {/* 新增檔案 */}
      <Dialog
        hasMask
        className={styles.dialogFile}
        visible={fileDialog}
        onOk={() => {
          form.submit();
        }}
        onCancel={() => {
          setFileDialog(false);
        }}
        onClose={() => {
          setFileDialog(false);
        }}
      >
        <h3>{fileStatus === 'insert' ? '新增' : '修改'}檔案</h3>
        <Form
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 20 }}
          form={form}
          onFinish={onFinish}
        >
          <Form.Item
            name="category"
            label="檔案類型"
            rules={[
              {
                required: true,
                message: '請選擇類型',
              },
            ]}
          >
            <Select>
              {categoryDataArr.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="database"
            label="服務類型"
            rules={[
              {
                required: true,
                message: '請選擇服務類型',
              },
            ]}
          >
            <Select>
              {serviceCategories.map((s) => (
                <Option key={s.id} value={s.id}>
                  {s.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="上傳檔案"
            name="files"
            rules={[
              {
                required: true,
                message: '請上傳檔案',
              },
            ]}
          >
            <Button
              onClick={() => {
                uploadRef.current.click();
              }}
            >
              {attachment ? '更換' : '上傳'}
            </Button>
            {editFileList && !uploadData && (
              <>
                <Typography.Text type="secondary">
                  {editFileList.orignalName.split('/')[1]}
                </Typography.Text>
              </>
            )}
            {uploadData && (
              <>
                <Typography.Text type="secondary">
                  {uploadData.name}
                </Typography.Text>
                <Button
                  text
                  onClick={() => {
                    setUploadData(null);
                    form.setFieldsValue({
                      files: null,
                    });
                  }}
                  style={{ opacity: 0.45 }}
                >
                  清除
                </Button>
              </>
            )}
            <input
              ref={uploadRef}
              type="file"
              id="upload"
              style={{ display: 'none' }}
              onChange={(e) => {
                const file = e.target.files[0];
                setUploadData(file);
                form.setFieldsValue({
                  files: [file],
                });
              }}
            />
          </Form.Item>
        </Form>
      </Dialog>
    </div>
  );
};

export default CommunityFilesList;
